
import { prokeyApi } from 'api/prokey';

//#region [Main] Constants

export const constants = {
  CLEAR: 'CLEAR',
  SET_USERS: 'SET_USERS',
  SET_ROLES: 'SET_ROLES',
  SET_MODULES: 'SET_MODULES'
}

//#endregion

//#region [Main] Actions

export const actions = {
  setUsers,
  setRoles,
  setModules
};

function setUsers(users) {
  return { type: constants.SET_USERS, payload: users };
}

function setRoles(roles) {
  return { type: constants.SET_ROLES, payload: roles };
}

function setModules(modules) {
  return { type: constants.SET_MODULES, payload: modules };
}

//#endregion

//#region [Main] Reducers

const initialState = {users: [], roles: [], modules: []};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case constants.CLEAR: {
      return initialState;
    }
    case constants.SET_USERS: {
      let newState = {...state};
      newState.users = action.payload;
      return newState;
    }
    case constants.SET_ROLES: {
      let newState = {...state};
      newState.roles = action.payload;
      return newState;
    }
    case constants.SET_MODULES: {
      let newState = {...state};
      newState.modules = action.payload;
      return newState;
    }
    default:
      return state
  }
}

//#endregion